import React, { useEffect, useState } from "react";
import {
  Flex,
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Button,
  Box,
  Input,
  useToast,
  SimpleGrid,
  Image,
  useBreakpointValue,
  Select,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Textarea,
  Badge,
  Switch,
} from "@chakra-ui/react";
import { MdDelete, MdEdit, MdDone, MdCancel, MdAdd } from "react-icons/md";
import Card from "components/card/Card";
import fetchWithToken from "views/auth/signIn/axiosInstance";
import { useTranslation } from "react-i18next";
import InsertItemService from "./InsertItemService";

const ListItemServices = ({ serviceId, serviceCode }) => {
  console.log("Service ID:", serviceCode);
  const { t } = useTranslation();
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();

  // Local states
  const [itemServices, setItemServices] = useState([]);
  const [filteredItemServices, setFilteredItemServices] = useState(itemServices);
  const [error] = useState("");
  const [editableItemService, setEditableItemService] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const isMobile = useBreakpointValue({ base: true, md: false });
  const pageId = 13; // Page ID for item services management
  const [permissions, setPermissions] = useState({ canList: true, canEdit: true, canDelete: true, canInsert: true });    // New states for category functionality
  const [isLaundryService, setIsLaundryService] = useState(false);
  const [categories, setCategories] = useState([]);
  // Check if service is laundry and fetch categories

  
  useEffect(() => {
    const fetchCategoriesIfLaundry = async () => {
      try {
        // Check if service code indicates laundry service
        if (serviceCode === 'UC001') {
          setIsLaundryService(true);
          
          // Fetch laundry categories
          const categoriesResponse = await fetchWithToken(
            `${process.env.REACT_APP_API_URL}/laundry/categories?page_id=${pageId}`,
            "GET"
          );
          
          if (categoriesResponse.data && categoriesResponse.data.length > 0) {
            setCategories(categoriesResponse.data);
          } else {
            setCategories([]);
          }
        } else {
          setIsLaundryService(false);
          setCategories([]);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
        setIsLaundryService(false);
        setCategories([]);
      }
    };

    if (serviceCode) {
      fetchCategoriesIfLaundry();
    }
  }, [serviceCode, pageId]);

  useEffect(() => {
    try {
      const role = JSON.parse(sessionStorage.getItem("permissions") || "{}");
      if (!role.permissions) {
        toast({
          title: "No permissions found",
          description: error.message || "You don't have the required access.",
          status: "error",
          duration: 3000,
          isClosable: true,
position: "top-right",

        });
        return;
      }

      const permission = role.permissions.find((p) => p.page_id === pageId);
      if (permission) {
        setPermissions({
          canList: permission.read_all_access || false,
          canEdit: permission.update_access || false,
          canDelete: permission.delete_access || false,
          canInsert: permission.insert_access || false,
        });
      }
    } catch (error) {
      toast({
        title: "Error loading permissions",
        description: error.message || "Something went wrong while fetching permissions.",
        status: "error",
        duration: 3000,
        isClosable: true,        position: "top-right",
      });
    }
  }, [toast, error.message, serviceId]);
  
  useEffect(() => {
    const fetchItemServices = async () => {
      try {
        // Removed pagination parameters
        const url = `${process.env.REACT_APP_API_URL}/global-items/item?page_id=${pageId}&service_id=${serviceId}`;
        const data = await fetchWithToken(url);
        setItemServices(data.data);
        setFilteredItemServices(data.data);
      } catch (error) {
        toast({
          title: "Error ",
          description: error.message || "Something went wrong.",
          status: "error",
          duration: 3000,
          isClosable: true,
          position: "top-right",
        });

      }    };
    fetchItemServices();
  }, [serviceId, toast]);

  // useEffect(() => {
  //   const fetchItems = async () => {
  //     try {
  //       // Updated endpoint for global items (without page parameters)
  //       const data = await fetchWithToken(
  //         `${process.env.REACT_APP_API_URL}/api/v1/global-items`,
  //         "GET"
  //       );
  //       setItems(data.data);
  //     } catch (error) {
  //       setError(error.message);
  //     }
  //   };

  //   fetchItems();
  // }, []);

  const handleDeleteItemService = async (itemServiceId) => {
    try {
      await fetchWithToken(
        `${process.env.REACT_APP_API_URL}/global-items/global-item/delete?id=${itemServiceId}&page_id=${pageId}`,
        "DELETE"
      );
      setItemServices(itemServices.filter(itemService => itemService.id !== itemServiceId));
      setFilteredItemServices(filteredItemServices.filter(itemService => itemService.id !== itemServiceId));
      toast({
        title: t("Item Deleted successfully!"),
        status: "success",
        duration: 2000,
        isClosable: true,
        position: "top-right",
      });

      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      toast({
        title: "Error Deleting Item",
        description: error.message || "Something went wrong .",
        status: "error",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });
    }
  };
  const handleEditItemService = (itemService) => {
    // Set the laundry_category_id if it exists in the laundry_category object
    const editableItem = {
      ...itemService,
      laundry_category_id: itemService.laundry_category?.id || ""
    };
    setEditableItemService(editableItem);
  };
  // Updated handleSaveItemService per the new API specification.
  const handleSaveItemService = async () => {
    try {
      // Only send image if it's a new base64 string (user selected a new image)
      const { image_url, ...rest } = editableItemService;
      let data = {
        id: editableItemService.id,
        name: editableItemService.name,
        description: editableItemService.description,
        service_name: editableItemService.service_name,
        translation_key: editableItemService.translation_key,
        size: editableItemService.size,
        hair_size: editableItemService.hair_size,
        status: editableItemService.status,
      };
      // Add image only if it's a new base64 string
      if (image_url && typeof image_url === 'string' && image_url.startsWith('data:image/')) {
        data.image = image_url;
      }
      // Add laundry_category_id for laundry services
      if (isLaundryService && editableItemService.laundry_category_id) {
        data.laundry_category_id = parseInt(editableItemService.laundry_category_id);
      }
      data = {
        ...data,
        ...(editableItemService.translations ? { translations: editableItemService.translations } : {}),
      };
      await fetchWithToken(
        `${process.env.REACT_APP_API_URL}/global-items/global-item/update?page_id=${pageId}`,
        "PATCH",
        data
      );

      setItemServices(prevItemServices =>
        prevItemServices.map(itemService =>
          itemService.id === editableItemService.id
            ? { ...editableItemService, ...itemService }
            : itemService
        )
      );
      setFilteredItemServices(prevFilteredItemServices =>
        prevFilteredItemServices.map(itemService =>
          itemService.id === editableItemService.id
            ? { ...editableItemService, ...itemService }
            : itemService
        )
      );
      setEditableItemService(null);
      toast({
        title: t("Item Updated successfully!"),
        status: "success",
        duration: 2000,
        isClosable: true,
        position: "top-right",

      });

      setTimeout(() => {
        // window.location.reload();
      }, 1000);
    } catch (error) {
      toast({
        title: "Error Updating Item",
        description: error.message || "Something went wrong.",
        status: "error",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });
    }
  };

  const handleSearch = (event) => {
  const query = event.target.value;
  setSearchQuery(query);

  // Ensure itemServices is an array before filtering
  if (!Array.isArray(itemServices)) {
    setFilteredItemServices([]);
    return;
  }

  const filtered = itemServices.filter(itemService =>
    itemService.id
      ? (itemService.item_name || itemService.name || "")
          .toLowerCase()
          .includes(query.toLowerCase())
      : (itemService.servicetype_name || itemService.package_name || itemService.name || "")
          .toLowerCase()
          .includes(query.toLowerCase())
  );
  setFilteredItemServices(filtered);
};

  // Render desktop table without pagination.
  const renderDesktopTable = () => {
    if (!filteredItemServices || filteredItemServices.length === 0) {
      return (
        <Box p="20px" textAlign="center">
          <Text fontSize="xl" color="gray.500">
            {t("No item services found")}
          </Text>
        </Box>
      );
    }

    return (  
        <Box overflowX="auto" maxHeight="400px" px="20px">
 <Table variant="striped" colorScheme="gray" mb="24px" size="sm">
   <Thead style={{ position: 'sticky', top: 0, zIndex: 2 }}>
                <Tr bg='rgb(69, 50, 240)' textColor="white" style={{ position: 'sticky', top: 0, zIndex: 2 }}>
      <Th minWidth="60px" color="white">{t("Image")}</Th>
      <Th minWidth="180px" color="white">{t("Name")}</Th>
      <Th minWidth="220px" color="white">{t("Description")}</Th>
      <Th minWidth="160px" color="white">{t("Size")}</Th>
    {serviceCode === "UC002" && (
          <Th minWidth="160px" color="white">{t("Hair Size")}</Th>
        )}   
           {isLaundryService && (
        <Th minWidth="180px" color="white">{t("Category")}</Th>
      )}
      <Th minWidth="220px" color="white">{t("Translations")}</Th>
      <Th minWidth="160px" color="white">{t("Status")}</Th>
      <Th minWidth="160px" color="white">{t("Actions")}</Th>
    </Tr>
  </Thead>

  <Tbody>
    {filteredItemServices.map((itemService, index) => (
      <Tr
        key={itemService.id}
        bg={editableItemService?.id === itemService.id ? "blue.50" : "transparent"}
        borderWidth={editableItemService?.id === itemService.id ? "2px" : "0"}
        borderColor={editableItemService?.id === itemService.id ? "blue.400" : "transparent"}
        _hover={{
          bg: editableItemService?.id === itemService.id ? "blue.100" : "gray.50",
        }}
      >
        {/* Index */}
  <Td minWidth="120px">
          {editableItemService?.id === itemService.id ? (
            <Input
              type="file"
              accept="image/*"
              onChange={(e) => {
                const file = e.target.files[0];
                if (file) {
                  const reader = new FileReader();
                  reader.onloadend = () => {
                    setEditableItemService({
                      ...editableItemService,
                      image_url: reader.result,
                    });
                  };
                  reader.readAsDataURL(file);
                }
              }}
              focusBorderColor="blue.400"
              borderColor="blue.300"
            />
          ) : itemService.image_url ? (
            <Image
              src={itemService.image_url}
              alt={itemService.name}
              boxSize="50px"
              objectFit="cover"
            />
          ) : (
            <Text>{t("No Image")}</Text>
          )}
        </Td>
        {/* Name */}
        <Td minWidth="180px">
          {editableItemService?.id === itemService.id ? (
            <Input
              variant="filled"
              placeholder={t("Name")}
              value={editableItemService.name}
              onChange={(e) =>
                setEditableItemService({
                  ...editableItemService,
                  name: e.target.value,
                })
              }
              fontSize={{ base: "sm", md: "md" }}
              width="100%"
              mb={2}
              focusBorderColor="blue.400"
              borderColor="blue.300"
            />
          ) : (
            <Text
              maxWidth="180px"
              fontSize={{ base: "sm", md: "md" }}
              whiteSpace="pre-wrap"
              wordBreak="break-word"
            >
              {itemService.name}
            </Text>
          )}
        </Td>

        {/* Description */}
        <Td minWidth="220px">
          {editableItemService?.id === itemService.id ? (
            <Textarea
              resize="vertical"
              rows={2}
              value={editableItemService.description}
              onChange={(e) =>
                setEditableItemService({
                  ...editableItemService,
                  description: e.target.value,
                })
              }
              width="100%"
              fontSize={{ base: "sm", md: "md" }}
              focusBorderColor="blue.400"
              borderColor="blue.300"
            />
          ) : (
            <Text
              maxWidth="220px"
              fontSize={{ base: "sm", md: "md" }}
              whiteSpace="pre-wrap"
              wordBreak="break-word"
            >
              {itemService.description}
            </Text>
          )}
        </Td>

        {/* Size */}
        <Td minWidth="160px">
          {editableItemService?.id === itemService.id ? (
            <Select
              variant="filled"
              value={editableItemService.size}
              onChange={(e) =>
                setEditableItemService({
                  ...editableItemService,
                  size: e.target.value,
                })
              }
              fontSize={{ base: "sm", md: "md" }}
              focusBorderColor="blue.400"
              borderColor="blue.300"
            >
              <option value="small">{t("Small")}</option>
              <option value="medium">{t("Medium")}</option>
              <option value="large">{t("Large")}</option>
            </Select>
          ) : (
            <Text fontSize={{ base: "sm", md: "md" }}>
              {itemService.size}
            </Text>
          )}
        </Td>
        {serviceCode === "UC002" && (
        <Td minWidth="160px">
          {editableItemService?.id === itemService.id ? (
            <Select
              variant="filled"
              value={editableItemService.hair_size}
              onChange={(e) =>
                setEditableItemService({
                  ...editableItemService,
                  hair_size: e.target.value,
                })
              }
              fontSize={{ base: "sm", md: "md" }}
              focusBorderColor="blue.400"
              borderColor="blue.300"
            >
              <option value="short">{t("Short")}</option>
              <option value="long">{t("Long")}</option>
            </Select>
          ) : (
            <Text fontSize={{ base: "sm", md: "md" }}>
              {itemService.hair_size}
            </Text>
          )}
        </Td>
      )}

        {/* Category */}
        {isLaundryService && (
          <Td minWidth="180px">
            {editableItemService?.id === itemService.id ? (
              <Select
                variant="filled"
                value={editableItemService.laundry_category_id || ""}
                onChange={(e) =>
                  setEditableItemService({
                    ...editableItemService,
                    laundry_category_id: e.target.value,
                  })
                }
                fontSize={{ base: "sm", md: "md" }}
                focusBorderColor="blue.400"
                borderColor="blue.300"
              >
                {categories.map((category) => (
                  <option key={category.id} value={category.id}>
                    {category.name}
                  </option>
                ))}
              </Select>
            ) : (
              <Text fontSize={{ base: "sm", md: "md" }}>
                {itemService.laundry_category?.name || t("No Category")}
              </Text>
            )}
          </Td>
        )}

        {/* Translations */}
        <Td minWidth="220px">
          {editableItemService?.id === itemService.id ? (
            <Flex direction="column" gap={2}>
              <Flex align="center">
                <Text fontWeight="bold" minWidth="50px" mr={2}>Key:</Text>
                <Input
                  value={editableItemService.translation_key || ""}
                  size="sm"
                  isDisabled
                  focusBorderColor="blue.400"
                  borderColor="blue.300"
                />
              </Flex>
              <Flex align="center">
                <Text fontWeight="bold" minWidth="50px" mr={2}>IT:</Text>
                <Input
                  value={editableItemService.translations?.it || ""}
                  onChange={(e) =>
                    setEditableItemService({
                      ...editableItemService,
                      translations: {
                        ...editableItemService.translations,
                        it: e.target.value,
                      },
                    })
                  }
                  size="sm"
                  focusBorderColor="blue.400"
                  borderColor="blue.300"
                />
              </Flex>
              <Flex align="center">
                <Text fontWeight="bold" minWidth="50px" mr={2}>FR:</Text>
                <Input
                  value={editableItemService.translations?.fr || ""}
                  onChange={(e) =>
                    setEditableItemService({
                      ...editableItemService,
                      translations: {
                        ...editableItemService.translations,
                        fr: e.target.value,
                      },
                    })
                  }
                  size="sm"
                  focusBorderColor="blue.400"
                  borderColor="blue.300"
                />
              </Flex>
            </Flex>
          ) : (
            <Flex direction="column">
              {itemService.translation_key && (
                <Text fontSize="sm" fontWeight="medium">
                  Key: {itemService.translation_key}
                </Text>
              )}
              {itemService.translations?.it && (
                <Text fontSize="sm">IT: {itemService.translations.it}</Text>
              )}
              {itemService.translations?.fr && (
                <Text fontSize="sm">FR: {itemService.translations.fr}</Text>
              )}
              {!itemService.translation_key &&
                !itemService.translations?.it &&
                !itemService.translations?.fr && (
                  <Text fontSize="sm" color="gray.500">
                    {t("No translations")}
                  </Text>
                )}
            </Flex>
          )}
        </Td>

                   <Td>
         {editableItemService && editableItemService.id === itemService.id ? (
           <Flex align="center">
             <Switch
               isChecked={editableItemService?.status} // Use the boolean value directly
               onChange={(e) =>
                 setEditableItemService((prev) => ({
                   ...prev,
                   status: e.target.checked, // Update the boolean value
                 }))
               }
               colorScheme="cyan"
               mr={2}
             />
             <Badge
               colorScheme={editableItemService?.status ? "green" : "red"} // Check the boolean value
               variant="solid"
               px={2}
               py={1}
               borderRadius="md"
               fontSize="0.85em"
             >
               {editableItemService?.status ? t("Active") : t("Inactive")}
             </Badge>
           </Flex>
         ) : (
           <Badge
             colorScheme={itemService?.status ? "green" : "red"} // Check the boolean value
             variant="solid"
             px={2}
             py={1}
             borderRadius="md"
             fontSize="0.85em"
           >
             {itemService?.status ? t("Active") : t("Inactive")}
           </Badge>
         )}
       </Td>

        {/* Actions */}
        <Td minWidth="160px">
          {editableItemService?.id === itemService.id ? (
            <Flex>
              <Button
                colorScheme="green"
                size="sm"
                onClick={handleSaveItemService}
                borderRadius="full"
                leftIcon={<MdDone />}
              >
                {t("Save")}
              </Button>
              <Button
                colorScheme="red"
                size="sm"
                ml={2}
                onClick={() => setEditableItemService(null)}
                borderRadius="full"
                leftIcon={<MdCancel />}
              >
                {t("Cancel")}
              </Button>
            </Flex>
          ) : (
            <Flex>
              <Button
                colorScheme="cyan"
                size="sm"
                color="white"
                onClick={() => handleEditItemService(itemService)}
                borderRadius="full"
                leftIcon={<MdEdit />}
              >
                {t("Edit")}
              </Button>
              {/* <Button
                colorScheme="red"
                size="sm"
                ml={2}
                onClick={() =>
                  window.confirm(t("Are you sure you want to delete this item service?")) &&
                  handleDeleteItemService(itemService.id)
                }
                borderRadius="full"
                leftIcon={<MdDelete />}
              >
                {t("Delete")}
              </Button> */}
            </Flex>
          )}
        </Td>
      </Tr>
    ))}
  </Tbody>
</Table>

</Box>

    );
  };

  const renderMobileView = () => {
    if (!filteredItemServices || filteredItemServices.length === 0) {
      return (
        <Box p="20px" textAlign="center">
          <Text fontSize="xl" color="gray.500">
            {t("No item services found")}
          </Text>
        </Box>
      );
    }
  
    return (
      <SimpleGrid columns={{ base: 1 }} spacing={4} px="10px">
        {filteredItemServices.map((itemService) => (
          <Card key={itemService.id} p="4" borderRadius="md" shadow="md">
            <Box mb="3">
              <Text fontSize="sm" color="gray.500">
                {itemService.branch_name}
              </Text>
              <Text fontSize="sm" color="gray.500">
                {t("Client")}: {itemService.item_name}
              </Text>
            </Box>            <Box>
              <Text fontSize="sm">
                <b>{t("Status")}: </b> {itemService.service_type_name}
              </Text>
              <Text fontSize="sm">
                <b>{t("Total Price")}: </b> ${itemService.current_price}
              </Text>
              {isLaundryService && (
                <Text fontSize="sm">
                  <b>{t("Category")}: </b> {itemService.laundry_category?.name || t("No Category")}
                </Text>
              )}
              <Flex mt="3" wrap="wrap">
                <Button
                  colorScheme="cyan"
                  color="white"
                  isDisabled={!permissions.canEdit}
                  size="xs"
                  mr="2"
                  onClick={() => handleEditItemService(itemService)}
                  leftIcon={<MdEdit />}
                >
                  {t("Edit")}
                </Button>
                <Button
                  colorScheme="red"
                  isDisabled={!permissions.canDelete}
                  size="xs"
                  mr="2"
                  onClick={() => handleDeleteItemService(itemService.id)}
                  leftIcon={<MdDelete />}
                >
                  {t("Delete")}
                </Button>
              </Flex>
            </Box>
          </Card>
        ))}
      </SimpleGrid>
    );
  };

  return (
    <>
      <Card
        direction="column"
        w="100%"
        px="0px"
        overflowX={{ base: "scroll", lg: "hidden" }}
        boxShadow="lg"
      >
        <Flex
          px={{ base: "10px", md: "25px" }}
          justify="space-between"
          mb="20px"
          align="center"
          flexWrap="wrap"
        >
                  <Flex align="center">

          <Text
            color="black"
            fontSize={{ base: "18px", md: "22px" }}
            fontWeight="700"
            lineHeight="100%"
          >
            Item Services List
          </Text>
           <Button colorScheme="cyan" size="sm" onClick={onOpen} ml={2} color="white" leftIcon={<MdAdd />} >
              {t("Add Item Service")}
              

            </Button>
            </Flex>
          {error && <Text color="red.500">{error}</Text>}
          <Flex align="center">
            <Input
              placeholder="Search item services..."
              value={searchQuery}
              onChange={handleSearch}
              size="sm"
              w={{ base: "100%", md: "200px" }}
              mt={{ base: 2, md: 0 }}
            />
           
          </Flex>
        </Flex>
        {isMobile ? renderMobileView() : renderDesktopTable()}
      </Card>
      <Modal isOpen={isOpen} onClose={onClose} size={"xl"}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{t("Add Item Service")}</ModalHeader>
          <ModalCloseButton />          <ModalBody>
            <InsertItemService serviceId={serviceId} serviceCode={serviceCode} serviceName=""/>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ListItemServices;
